import React from 'react';
import PaginationTable from '../PaginationTable';

export default class UploadsShow extends React.Component {

    constructor(props) {
        super(props);
        this.renderMessages = this._renderMessages.bind(this);
        this.timeout = null;
        this.uploadID = parseInt(this.props.params.uploadID, 10);
    }

    componentWillMount() {
        this.props.fetchUpload(this.uploadID);
        this.props.fetchUploadMessages(this.uploadID);
    }

    componentWillReceiveProps(props) {
        const upload = props.uploadState.detail.upload;
        if(upload && (upload.status !== 'rejected' && upload.status !== 'done')) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.props.fetchUpload(this.uploadID);
                this.props.fetchUploadMessages(this.uploadID, this.props.uploadState.detail.messages.current_page);
            }, 10000);
        }
    }

    
    render() {
        const state = this.props.uploadState.detail;
        if(! state.upload) {
            return (
                <div className="container">
                    <i className="fa fa-spinner fa-spin"></i> Cargando
                </div>
            );
        }
        const fetching = state.fetching;
        const upload = state.upload;
        const loader = <i className="fa fa-spinner fa-spin"></i>;
        let icon;
        switch(upload.status) {
            case 'pending' :
                icon = (<i className="fa fa-circle-o fa-fw"></i>);
                break;
            case 'processing' :
                icon = (<i className="fa fa-spinner fa-spin fa-fw"></i>);
                break;
            case 'done' :
                icon = (<i className="fa fa-check fa-fw"></i>);
                break;
            case 'rejected' :
                icon = (<i className="fa fa-times fa-fw"></i>);
                break;
            default :
                icon = null;
                break;
        }
        return (
            <div className="container">
                <h3>
                    {upload.file_name} {icon}
                </h3>
                <div className="row mb-2">
                    <div className="col-md-4">
                        <div className="card">
                            <div className="bg-success p-2 text-white">
                                <p className="text-center h5 m-0">
                                    {fetching ? loader :upload.created}
                                </p>
                            </div>
                            <div className="text-center px-2 py-1">
                                Registros creados
                            </div>
                        
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card">
                            <div className="bg-info p-2 text-white">
                                <p className="text-center h5 m-0">
                                    {fetching ? loader :upload.updated}
                                </p>
                            </div>
                            <div className="text-center px-2 py-1">
                                Registros actualizados
                            </div>
                        
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card">
                            <div className="bg-danger p-2 text-white">
                                <p className="text-center h5 m-0">
                                    {fetching ? loader :upload.with_error}
                                </p>
                            </div>
                            <div className="text-center px-2 py-1">
                                Registros con error
                            </div>
                        
                        </div>
                    </div>
                </div>
                {this.renderMessages()}
            </div>
        );
    }

    _renderMessages() {
        const upload = this.props.uploadState.detail.upload;
        if(upload === null) return null;
        const messagesData = this.props.uploadState.detail.messages;
        const renderHeader = () => {
            return (
                <tr>
                    <th>Fila</th>
                    <th>SIC</th>
                    <th>Error</th>
                </tr>
            )
        }

        const renderRow = (props) => {
            return (
                <tr>
                    <td>{props.item.row}</td>
                    <td>{props.item.sic}</td>
                    <td>{props.item.message}</td>
                </tr>
            )
        }

        const pageChange = (page) => {
            this.props.fetchUploadMessages(upload.id, page);
        }
        return (
            <PaginationTable {...messagesData} headerComponent={renderHeader} rowComponent={renderRow} pageChange={pageChange}/>
        );  
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/uploads/UploadsShow.jsx
 **/